import { Button, Divider, Stack, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import NestedContentComponent from '../NestedContentComponent'
import AssignAndManageProjectComponent from './AssignAndManageProjectComponent'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { AssignProject } from '../../models/Review'
import { setSelectedProject } from '../../actions/review'
import { createSelector } from '@reduxjs/toolkit'

const userSelector = createSelector(
  [(state: RootState) => state.auth],
  (auth) => auth.user,
)
const selectedProjectSelector = createSelector(
  [(state: RootState) => state.review],
  (review) => review.selectedProject,
)

interface ProjectDetailsProps {
  project: AssignProject
}

const ProjectDetailsComponent: React.FC<ProjectDetailsProps> = ({
  project,
}) => {
  const dispatch = useDispatch()
  const user = useSelector(userSelector)
  const selectedProject = useSelector(selectedProjectSelector)

  const handleProjectClick = () => {
    dispatch(setSelectedProject(project.id))
  }

  return (
    <Button
      disableRipple
      onClick={handleProjectClick}
      sx={{
        display: 'flex',
        width: '100%',
        boxSizing: 'border-box',
        p: '1rem',
        background: '#F5F5F1',
        boxShadow: '0px 2px 10px 0px #0000001A',
        borderRadius: '6px',
        mb: '1rem',
        textTransform: 'none',
        textAlign: 'left',
        border:
          selectedProject?.id === project.id
            ? '2px solid #1705E5'
            : '2px solid transparent',
        '&:hover': {
          border: '2px solid #1705E5',
        },
      }}
    >
      <Stack gap='0.75rem' sx={{ width: '100%' }}>
        <Box
          gap={'15px'}
          sx={{
            width: '100%',
            display: 'flex',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Stack gap='0.3rem'>
                <Typography
                  sx={{
                    color: '#04002E',
                    fontSize: '0.88rem',
                    fontWeight: 500,
                    lineHeight: 'normal',
                  }}
                >
                  {project.file.name}
                </Typography>
                <Typography
                  sx={{
                    color: '#878787',
                    fontSize: '0.82rem',
                    lineHeight: 'normal',
                  }}
                >
                  San Diego, CA
                </Typography>
                <Divider sx={{ background: '#A2B0C6' }} />
                <Typography
                  sx={{
                    color: '#878787',
                    fontSize: '0.76rem',
                    lineHeight: 'normal',
                  }}
                >
                  Client Name
                </Typography>
              </Stack>
            </Box>
            <Box>
              <Stack gap='0.3rem'>
                <Box
                  sx={{
                    display: 'flex',
                    gap: '10px',
                  }}
                >
                  <Typography
                    component='div'
                    sx={{
                      fontWeight: 400,
                      color: '#04002E',
                      fontSize: '0.7rem',
                    }}
                  >
                    3 BR
                  </Typography>
                  <Divider flexItem orientation='vertical' sx={{ my: '2px' }} />
                  <Typography
                    component='div'
                    sx={{
                      fontWeight: 400,
                      color: '#04002E',
                      fontSize: '0.7rem',
                    }}
                  >
                    2 BA
                  </Typography>
                  <Divider flexItem orientation='vertical' sx={{ my: '2px' }} />
                  <Typography
                    component='div'
                    sx={{
                      fontWeight: 400,
                      color: '#04002E',
                      fontSize: '0.7rem',
                    }}
                  >
                    1 FL
                  </Typography>
                </Box>
                <Divider sx={{ background: '#A2B0C6' }} />
                <Typography
                  sx={{
                    color: '#06004A',
                    fontSize: '0.64rem',
                    lineHeight: 'normal',
                  }}
                >
                  Edited: 2d ago
                </Typography>
              </Stack>
            </Box>
          </Box>
          <Box
            component='img'
            src='/images/projectThumbnail.png'
            alt='Project Thumbnail'
            sx={{
              width: '57%',
              borderRadius: '2px',
            }}
          ></Box>
        </Box>
        <Divider sx={{ background: '#A2B0C6' }} />
        <NestedContentComponent
          title={
            <Typography sx={{ color: '#797979', fontSize: '0.67rem' }}>
              Assign and Manage
            </Typography>
          }
          titlePadding={'0 1rem 0 0'}
          arrowColor='#04002E'
        >
          {!!user && (
            <AssignAndManageProjectComponent
              role={user.role}
              project={project}
            />
          )}
        </NestedContentComponent>
      </Stack>
    </Button>
  )
}

export default ProjectDetailsComponent
